module.exports = __webpack_public_path__ + "static/media/equipe-tindog2.c0cb89cd.png";